// extracted by mini-css-extract-plugin
module.exports = {"listAH5":"listA_listAH5__CelYl"};